export default "__VITE_ASSET__DXE6waq6__"